import styled from "styled-components";

export const ReportProcessingContainer = styled.div`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  .img-processing {
    height: 20.6rem;
    width: 20.1rem;
  }
  .close-modal-button {
    display: flex;
    justify-content: end;
    margin-top: 1.5rem;
  }
  .close-button {
    cursor: pointer;
    padding: 0.3rem;
  }
`;

export const ReportLoadingReport = styled.div`
  ${(props) => `
      align-items: center;
      background-color: #FFF;
      border-radius: 50%;
      display: flex;
      font-family: ${props.theme.fontFamilies.primaryFont};
      height: 11rem;
      justify-content: center;
      margin-top: -6rem;
      position: absolute;
      width: 11rem;
  `}
  .img-processing-report {
    height: 9rem;
    width: 9rem;
  }
`;

export const ReportProcessingContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-top: 5.3rem;
    font-size: 2rem;
    font-family: Montserrat;
    color: #2e353d;
    font-weight: 800;
  }
  p {
    font-size: 1.4rem;
    font-family: Montserrat;
    text-align: center;
    color: #000000;
    width: 39rem;
    line-height: 2.2rem;
  }
`;
